import React, { Component } from 'react';
import './index.css';

import { Layout, Row, Col, List, Tabs } from 'antd';

const TabPane = Tabs.TabPane;
const { Header, Content } = Layout;

class DemoList extends Component {
  state = {
    marketing: [
      {
        Name: 'Customer Segmentation',
        Description: 'Dynamic Segmentation of customers by their recency, frequency and monetary scores',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vQuuZS42j17DVcqmSzqD6keP4N3MbF-QsBrbtCKHq-ThbBaAhukK0kL5b2Y_ZKheR8Op_whvXmwHWWd/pub?start=true&loop=true&delayms=3000#slide=id.g3e314c3b80_0_448',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/segmentation.html',
          Demo: 'https://storage.googleapis.com/demo-portal-static/demo/segmentation.gif',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Customer_Segmentation&t=finalRetails&page=table',
          Source: 'https://storage.googleapis.com/demo-portal-static/models/segmentation.html',
        }
      },
      {
        Name: 'Targeted campaigns by customer behaviour',
        Description: 'Figure customers’ next best action',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vTNAYyo-uXxGN3RZkofgNrdR2gDv9yidG283L3F4HhSLQ57-zVCwFyy3AXeEexisiu5tTLLPesJK1IG/pub?start=true&loop=true&delayms=3000#slide=id.g3e3081a1ef_0_0',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/email_open_rate.html',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Retail_Analytics&t=Open_Behaviour&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/Targeted_Campaigns',
          Architecture: 'https://storage.googleapis.com/demo-portal-static/arch/targeted_campaign.png',
        }
      },
      {
        Name: 'Churn Prediction for Renewals',
        Description: 'Machine predicts customers who are not engaged with your brand from purchase & pipeline data',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vQV7FsdRx1RqvK8ORhNDeYzPqd7hrfT9K_sVtweH0k2XFTUudA5FGKlamDDQ3q6E-D5xMGucRn0Krcw/pub?start=true&loop=true&delayms=5000#slide=id.g3da0bb1e5d_0_129',
          Demo: 'https://10ay.online.tableau.com/t/tableauonlinedemositeforpartners/views/ChurnRisk_Update/RenewalsChurnRiskDashboard?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no#3',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Churn_Risk&t=Renewals_Churn_Risk&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/churn_pred',
        }
      },
      {
        Name: 'Recommendations',
        Description: 'Product recommendations to customers based on the similarity in customers\' buying pattern',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vT-BFErhKAeUGc_Bm0bqT7JdoijfTZOTsYZOcgIDa1xyYy1X95Pjbq8_qYeKZ8zjVimPzlTy09Z29kj/pub?start=true&loop=true&delayms=3000#slide=id.g3e315ba918_0_0',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/diamonds_in_the_rough.html',
          Demo: 'https://10ay.online.tableau.com/t/tableauonlinedemositeforpartners/views/RecommendationsV3/Dashboard1?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Recommendation&t=Transactions&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/Diamonds_in_the_rough',
        }
      },
      {
        Name: 'Diamonds in the Rough',
        Description: 'ML model to proactively identify customers who can become named accounts using the buying pattern',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vS1Ox7LXPSorgT3IW33mB2z9E9BzbKrR7vtxugSVeXOGFave0xmVUgExfVg2_h1A7tSCDWC2-vBRRM1/pub?start=true&loop=true&delayms=10000#slide=id.g3e374d699a_0_0',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/diamonds_in_the_rough.html',
          Demo: 'https://10ay.online.tableau.com/t/tableauonlinedemositeforpartners/views/Diamondsintherough/DiamondintheRough-Dashboard?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Diamonds_In_The_Rough&page=dataset',
          Source: 'https://github.com/Pluto7-Consulting-Inc/Diamonds_in_the_rough',
        }
      },
    ],
    demand: [
      {
        Name: 'Store Traffic Prediction',
        Description: 'Predict the foot traffic for stores based on the history and weather data',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vRfqF1npbQLMtrptCqUKlvoogvk-PFvhPLsoPKJV65W5DNqXvkfdLJ0GW91JN-1tw8BHADBy4a4SJWJ/pub?start=true&loop=true&delayms=10000#slide=id.g3e31548da5_0_8',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/store_traffic.html',
          Demo: 'https://storage.googleapis.com/demo-portal-static/demo/instore.png',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Instore_Traffic&t=Instore&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/StoreTraffic',
        }
      },
      {
        Name: 'Sales Prediction',
        Description: 'Predict Sales & Forecast Demand using Machine Learning',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vQ5opfXSsuaPvuR80ELiY67V4oJTl2wCc0NMYCLYzuZL4xqqX_GmXn8mnb7SWMCjlQyJOrss_fZYbt_/pub?start=true&loop=true&delayms=3000#slide=id.g3a0c80b60c_0_31',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/sales_pred.html',
          Demo: 'https://storage.googleapis.com/demo-portal-static/demo/sales_pred.png',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Sales_Prediction&t=Shipment_Info&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/DemandML',
        }
      },
    ],
    others: [
      {
        Name: 'Preventive Maintenance',
        Description: 'Model which tells you when to change the filter used in beer manufactufing based on various sensors\' input',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vRKG6W1ZsZPaq-BsakGUAo-4JMxDfkFZnKHYN4o3MqkO266lOHWWFUU8Wv8vJEKmlyCDtvm1eeVGh6U/pub?start=true&loop=true&delayms=3000#slide=id.g3a0c80b60c_0_31',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/prev_maintenance.html',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Preventive_Maintenance_Filter&t=Sensor_Values&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/filter_data',
          Architecture: 'https://storage.googleapis.com/demo-portal-static/arch/prev_maintenance.jpg',
        }
      },
      {
        Name: 'Preventive care - Diabetic Detection',
        Description: 'Predicts diabetes with Data ahead in time using Machine Learning',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vQWksKE0ZHCHhSdaRr-HCgFiNWxvJ2rBGt0INgfv-iu76DfRdYTIZxh2LwUCW8rWJ49nwjMp4MNHQdM/pub?start=true&loop=true&delayms=3000#slide=id.g3a0c80b60c_0_31',
          Insights: 'https://storage.googleapis.com/demo-portal-static/insights/diabetes.html',
          Demo: '/models/diabetes/predict',
          Data: 'https://console.cloud.google.com/bigquery?project=ml-demo-209802&p=ml-demo-209802&d=Diabetes&t=People_Info&page=table',
          Source: 'https://github.com/Pluto7-Consulting-Inc/Diabetes_model-with-Estimator_api',
        }
      },
    ],
    sentiment_analysis: [
      {
        Name: 'Product - SentimentPro',
        Description: 'Handy tool for the amazon sellers to get an overview from the 1000s of reviews they\'ve got',
        Links: {
          Slides: 'https://docs.google.com/presentation/d/e/2PACX-1vTrO0sD764FNy3on0g92o17fc5VDAZ6tRBV2CfcjSR5yqPvf2uXQkKCLmUCl_9LixT72D10dK4RKRO3/pub?start=true&loop=true&delayms=3000#slide=id.gd9c453428_0_16',
          Demo: 'https://pluto7.com/events/',
          Source: 'https://github.com/Pluto7-Consulting-Inc/Sentiment-Pro',
          Architecture: 'https://storage.googleapis.com/demo-portal-static/arch/sentimentpro.png',
        }
      }
    ]
  }

  render() {
    const { demand, marketing, others, sentiment_analysis } = this.state;
    return (
      <div className="App">
        <Layout>
          <Header>
            <Row>
            <Col span={21}>
              <h1 style={{color:"#fff"}}>Machine Learning Demo Portal</h1>
            </Col>
            <Col span={3}>
              <img src="/pluto7-white-logo.png" alt="Pluto7" width="90%"/>
            </Col>
            </Row>
          </Header>
          <Content>
            <Row>
            <Col span={20} offset={1}>
            <Tabs defaultActiveKey="1" tabPosition="left" size="large">
              <TabPane tab="Marketing" key="1">
                <List
                  className="demo-loadmore-list"
                  itemLayout="vertical"
                  dataSource={marketing}
                  renderItem={item => (
                    <List.Item actions={
                            Object.entries(item.Links).map(([key, value]) => {
                                    if (value !== '') {
                                    return <a target="_blank" href={value}>{key}</a>
                                    }
                                    else {
                                    return key
                                    }
                            }
                            )}>
                      <List.Item.Meta
                        title={item.Name}
                        description={item.Description}
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="Demand" key="2">
                <List
                  className="demo-loadmore-list"
                  itemLayout="vertical"
                  dataSource={demand}
                  renderItem={item => (
                    <List.Item actions={
                            Object.entries(item.Links).map(([key, value]) => {
                                    if (value !== '') {
                                    return <a target="_blank" href={value}>{key}</a>
                                    }
                                    else {
                                    return key
                                    }
                            }
                            )}>
                      <List.Item.Meta
                        title={item.Name}
                        description={item.Description}
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="Other models" key="3">
                <List
                  className="demo-loadmore-list"
                  itemLayout="vertical"
                  dataSource={others}
                  renderItem={item => (
                    <List.Item actions={
                            Object.entries(item.Links).map(([key, value]) => {
                                    if (value !== '') {
                                    return <a target="_blank" href={value}>{key}</a>
                                    }
                                    else {
                                    return key
                                    }
                            }
                            )}>
                      <List.Item.Meta
                        title={item.Name}
                        description={item.Description}
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="Sentiment Analysis" key="4">
                <List
                  className="demo-loadmore-list"
                  itemLayout="vertical"
                  dataSource={sentiment_analysis}
                  renderItem={item => (
                    <List.Item actions={
                            Object.entries(item.Links).map(([key, value]) => {
                                    if (value !== '') {
                                    return <a target="_blank" href={value}>{key}</a>
                                    }
                                    else {
                                    return key
                                    }
                            }
                            )}>
                      <List.Item.Meta
                        title={item.Name}
                        description={item.Description}
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
            </Tabs>
            </Col>
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default DemoList;



// WEBPACK FOOTER //
// ./src/models/list/index.js